import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpExpirationDateBeforeRuntimeStartValidator
     * @memberof app
     *
     * @restrict A
     * @scope false
     *
     * @description
     * Validates if the expiration date is before runtimeStart.
     * If runtimeStart is in the past and intraday-proposals are allowed, this is always valid.
     *
     * @attr {Date} ngModel expiration Date
     * @attr {Date} runtimeStart
     * @attr {boolean} intraDayAllowed
     *
     * @author somarten.btc
     */
    angular
        .module('app')
        .directive(
            'pkpExpirationDateBeforeRuntimeStartValidator',
            pkpExpirationDateBeforeRuntimeStartValidator
        );

    function pkpExpirationDateBeforeRuntimeStartValidator() {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, elem, attr, ngModelCtrl) {
            ngModelCtrl.$validators.pkpExpirationDateBeforeRuntimeStartValidator =
                validate;

            function validate(modelValue) {
                if (!modelValue || angular.isUndefined(attr.runtimeStart)) {
                    return true;
                }

                var now = moment();
                var runtimeStart = moment(scope.$eval(attr.runtimeStart));
                var expirationDate = moment(modelValue);
                var expirationDateBeforeStart =
                    expirationDate.isSameOrBefore(runtimeStart);
                var isIntraDayAllowed =
                    angular.isDefined(attr.intraDayAllowed) &&
                    scope.$eval(attr.intraDayAllowed);

                return (
                    expirationDateBeforeStart ||
                    (isIntraDayAllowed && runtimeStart.isSameOrBefore(now))
                );
            }

            scope.$watch(
                function () {
                    return scope.$eval(attr.runtimeStart);
                },
                function () {
                    ngModelCtrl.$validate();
                },
                true
            );
        }
    }
})();
